import React, {Component} from "react";
import {Link} from "react-router";
import ShelfNav from "../common/nav/ShelfNav";
import MarketingNav from "../common/nav/MarketingNav";
import Footer from "../../common/Footer";
import PricePlaceholder from "../common/PricePlaceholder";
import "./Product.css";
import FlappingBuild from "../img/flapping_build.png";
import {currentSiteName} from "../../service/SiteService";
import AnchorLink from "../../common/AnchorLink";

class Product extends Component {
    render() {
        return (
            <div>
                <ShelfNav/>

                <div className="stage" id="stage">

                    <div className="block block-inverse block-hero app-header"
                         style={{backgroundImage: 'url(assets/img/splash-background.jpg)'}}>

                        <MarketingNav/>

                        <div className="block-xs-middle p-b-lg">
                            <div className="container">
                                <div className="row">
                                    <div className="col-sm-10 col-md-6">
                                        <h1 className="block-title m-b-sm"><strong>Live Mocks for your APIs, in seconds</strong>.
                                        </h1>
                                        <p className="lead m-b-md text-muted">Get instant mocks from your OpenAPI specs
                                            and start coding against them. Goodbye to flaky tests.</p>
                                        <Link to="/register" className="btn btn-primary btn-lg m-t-sm-c-xs m-t-sm-c-sm m-r-sm">Try it now</Link>
                                        <AnchorLink anchorName="details" className="btn btn-info btn-lg m-t-sm-c-xs m-t-sm-c-sm">Learn more</AnchorLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section id="details">
                        <div className="block block-secondary app-iphone-block">
                            <div className="container">
                                <div className="row app-align-center">
                                    <div className="col-sm-5 hidden-xs">
                                        <img alt="Product screenshot on laptop" className="app-iphone"
                                             src={FlappingBuild} style={{width: '100%'}}/>
                                    </div>

                                    <div className="col-sm-6 col-sm-offset-1 m-b-md">
                                        <h3 className="m-t-0">Integration tests are important,<br className="visible-lg" /> but flaky.</h3>

                                        <p className="lead">Good integration tests help you build high quality software. But
                                            these often depend on unreliable third parties or external systems.</p>

                                        <blockquote className="m-t-sm">
                                            <p><strong>"Whenever a third party system goes down it breaks my integration tests!"</strong> <i
                                                className="em em-cry text-small"/></p>
                                            <cite className="small"><strong>Sad developers</strong></cite>
                                        </blockquote>

                                        <p className="lead">When your CI pipeline is unreliable you're
                                            wasting time and money.</p>

                                        <p className="lead"><strong className="m-t-0">There is an easier way.</strong> {currentSiteName} helps you avoid test
                                            failures caused by flaky third party systems.</p>
                                        <Link to="/register" className="btn btn-info btn-lg m-r-xs m-b-sm">
                                            Get started
                                        </Link>
                                        <Link to="/docs/mocks/getting-started" className="btn btn-default btn-lg m-b-sm">
                                            Learn how
                                        </Link>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="block block-inverse block-secondary app-code-block" id="features">
                            <div className="container">
                                <div className="row app-align-center">
                                    {/*<div className="col-md-4 col-md-push-8 col-lg-5 col-lg-push-6 hidden-xs hidden-sm">
                                        <div className="container m-t-sm code-callout">
                                            <img alt="Product logo" src={ProductLogo} className="feature-image-md"/>
                                        </div>
                                    </div>*/}

                                    <div className="col-md-10 col-md-offset-1 col-lg-10 col-lg-offset-2">
                                        <h6 className="text-muted text-uppercase">A better way</h6>
                                        <h3 className="m-t-0">A reliable way to mock API dependencies.</h3>

                                        <p className="lead m-b-md text-muted">
                                            Simply upload an <a href="https://www.openapis.org/" target="_blank">OpenAPI</a> file to {currentSiteName} and it builds a mock of the API, and hosts it for you.
                                            It's an instant Live Mock of your API, built from your spec.
                                        </p>
                                        <p className="lead m-b-md text-muted">
                                            If you've tried maintaining custom mocks in the past, you know this means
                                            bespoke code and effort maintaining your CI pipeline. When
                                            mocks get out of sync with real API specifications you also have version management problems.
                                        </p>
                                        <p className="lead m-b-md text-muted">
                                            {currentSiteName} understand your endpoints,
                                            parameters and examples. It gives you an endpoint you can call from your tests,
                                            command line or web browser. Your mock is always in sync with your API spec,
                                            and requests are validated against it.
                                        </p>
                                        <Link to="/register" className="btn btn-info btn-lg btn-borderless m-r-xs m-b-sm">
                                            Get started
                                        </Link>
                                        <Link to="/docs" className="btn btn-default btn-lg btn-borderless m-b-sm">
                                            Read our docs
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="block block-secondary app-high-praise p-b-0"
                             style={{backgroundImage: 'url(assets/img/StockSnap_DWLWL9USBG.jpg)'}}>

                            <div className="container">
                                <div className="row app-align-center">
                                    <div className="col-sm-6 bg-primary"
                                         style={{paddingTop: "10px", paddingBottom: "2px"}}>
                                        <h6 className="text-muted text-uppercase" style={{color: 'white'}}>What we support</h6>
                                        <blockquote className="m-t-sm" style={{color: 'white'}}>
                                            <p>
                                                <i className="m-r-xs icon icon-check"/> OpenAPI specs
                                            </p>
                                            <p>
                                                <i className="m-r-xs icon icon-check"/> RESTful APIs
                                            </p>
                                            <p>
                                                <i className="m-r-xs icon icon-check"/> Request validation
                                            </p>
                                            <p>
                                                <i className="m-r-xs icon icon-check"/> Dynamic &amp; scripted responses
                                            </p>
                                            <p>
                                                <i className="m-r-xs icon icon-check"/> Latency simulation
                                            </p>
                                            <p>
                                                With the {currentSiteName} platform you get all this awesomeness for a tiny cost per month.
                                                For small projects, we have a free plan too.
                                            </p>
                                        </blockquote>
                                    </div>
                                    <div className="col-sm-6 col-sm-pull-5"/>
                                </div>
                            </div>
                        </div>
                    </section>

                    <PricePlaceholder/>

                    <Footer/>
                </div>
            </div>
        );
    }
}

export default Product;



// WEBPACK FOOTER //
// ./src/modules/views/mocks/Product.js